export default __webpack_public_path__ + "static/media/coupons-disabled.e4f69334.png";